import firebase from "../../firebase";

export default function({ officeId }) {
    return firebase.functions().httpsCallable("allFunctions")({
        funcRole: "messagingAdmin",
        funcName: "deleteAllMessages",
        data: { officeId }
    });
}
